import { Field } from 'devextreme/ui/pivot_grid/data_source';
import {
  termekek_group,
  tetelek_group,
  keszletek_group,
  felhasznalasi_cel_group,
  adozasi_szint_group
} from './common';

export const dimensiondata_2_dimension_1_w150: Field = {
  dataField: 'dimensiondata_2.label',
  sortBy: 'none',
  width: 150,
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_2_dimension_1: Field = {
  dataField: 'dimensiondata_2.label',
  sortBy: 'none',
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_2_dimension_2: Field = {
  ...dimensiondata_2_dimension_1,
  dataField: 'dimensiondata_2.child.label',
};

export const dimensiondata_2_dimension_3: Field = {
  ...dimensiondata_2_dimension_1,
  dataField: 'dimensiondata_2.child.child.label',
};

export const dimensiondata_2_dimension_4: Field = {
  ...dimensiondata_2_dimension_1,
  dataField: 'dimensiondata_2.child.child.child.label',
};

export const dimensiondata_2_dimension_5: Field = {
  ...dimensiondata_2_dimension_1,
  dataField: 'dimensiondata_2.child.child.child.child.label',
};

export const dimensiondata_2_tetelek: Field[] = [
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'tetelek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'tetelek', groupIndex: 4 },
];

export const dimensiondata_2_termekek: Field[] = [
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'termekek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'termekek', groupIndex: 4 },
];

export const dimensiondata_2_regiok_es_varmegyek: Field[] = [
  { ...dimensiondata_2_dimension_1, groupName: 'regiok_es_varmegyek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'regiok_es_varmegyek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'regiok_es_varmegyek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'regiok_es_varmegyek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'regiok_es_varmegyek', groupIndex: 4 },
];

export const dimensiondata_2_termekek_group_row: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  ...dimensiondata_2_termekek,
];

export const dimensiondata_2_termekek_group_first_row_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'termekek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'termekek', groupIndex: 4 },
];

export const dimensiondata_2_termekek_group_1_2_3_4_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'termekek', groupIndex: 3 },
];

export const dimensiondata_2_termekek_group_1_2_3_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
];

export const dimensiondata_2_termekek_group_1_2_3_column_first_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
];

export const dimensiondata_2_termekek_group_1_2_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
];

export const dimensiondata_2_termekek_group_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
];


export const dimensiondata_2_termekek_group_dimension_1_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
];

export const dimensiondata_2_termekek_1_2_group_dimension_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
];

export const dimensiondata_2_termekek_group_first_column_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'termekek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'termekek', groupIndex: 4 },
];

export const dimensiondata_2_termekek_group_1_2_3_4_first_column_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'termekek', groupIndex: 3 },
];

export const dimensiondata_2_termekek_group_1_2_3_first_column_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'termekek', groupIndex: 2 },
];

export const dimensiondata_2_termekek_group_dimension_1_2_row_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_2.ord',
    expanded: true,
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
];

export const dimensiondata_2_termekek_group_dimension_1_2_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
];

export const dimensiondata_2_termekek_group_dimension_1_2_column_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
    expanded: true,
  },
  { ...dimensiondata_2_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'termekek', groupIndex: 1 },
];

export const dimensiondata_2_tetelek_group_first_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'tetelek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'tetelek', groupIndex: 4 },
];

export const dimensiondata_2_tetelek_group_dimension_1_2_3_first_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },

];


export const dimensiondata_2_tetelek_group_dimension_1_2_3_row_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_2.ord',
    expanded: true,
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

export const dimensiondata_2_tetelek_group_dimension_1_2_3_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },
];

// export const dimensiondata_2_regiok_es_varmegyek_group_row: Field[] = [
//   {
//     ...regiok_es_varmegyek_group,
//     area: 'row',
//     sortBySummaryField: 'dimensiondata_2.ord',
//   },
//   ...dimensiondata_2_regiok_es_varmegyek,
// ];
//
export const dimensiondata_2_tetelek_group_dimension_1_first_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'tetelek', groupIndex: 3 },
  { ...dimensiondata_2_dimension_5, groupName: 'tetelek', groupIndex: 4 },
];

export const dimensiondata_2_tetelek_group_dimension_1_2_first_column_expanded: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0, expanded: true },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
];

export const dimensiondata_2_tetelek_group_dimension_1_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0 },
];

export const dimensiondata_2_tetelek_group_dimension_1_2_3_4_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord'
  },
  { ...dimensiondata_2_dimension_1, groupName: 'tetelek', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'tetelek', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'tetelek', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'tetelek', groupIndex: 3 },
];

export const dimensiondata_2_tetelek_group_column: Field[] = [
  {
    ...tetelek_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  ...dimensiondata_2_tetelek,
];

export const dimensiondata_2_keszletek_group_row: Field[] = [
  {
    ...keszletek_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1_w150, groupName: 'keszletek', groupIndex: 0 },

];

export const dimensiondata_2_felhasznalasi_cel_group_dimension_1_row: Field[] = [
  {
    ...felhasznalasi_cel_group,
    area: 'row',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1_w150, groupName: 'felhasznalasi_cel', groupIndex: 0 },

];

export const dimensiondata_2_felhasznalasi_cel_group_dimension_1_column: Field[] = [
  {
    ...felhasznalasi_cel_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1_w150, groupName: 'felhasznalasi_cel', groupIndex: 0 },

];

export const dimensiondata_2_felhasznalasi_cel_group_column: Field[] = [
  {
    ...felhasznalasi_cel_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'felhasznalasi_cel', groupIndex: 0 },

];

export const dimensiondata_2_felhasznalasi_cel_1_2_group_column: Field[] = [
  {
    ...felhasznalasi_cel_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'felhasznalasi_cel', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'felhasznalasi_cel', groupIndex: 1 },
];

export const dimensiondata_2_adozasi_szint_group_column: Field[] = [
  {
    ...adozasi_szint_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'adozasi_szint', groupIndex: 0 },

];

export const dimensiondata_2_adozasi_szint_group_dimension_1_2_3_4_colum: Field[] = [
  {
    ...adozasi_szint_group,
    area: 'column',
    sortBySummaryField: 'dimensiondata_2.ord',
  },
  { ...dimensiondata_2_dimension_1, groupName: 'adozasi_szint', groupIndex: 0 },
  { ...dimensiondata_2_dimension_2, groupName: 'adozasi_szint', groupIndex: 1 },
  { ...dimensiondata_2_dimension_3, groupName: 'adozasi_szint', groupIndex: 2 },
  { ...dimensiondata_2_dimension_4, groupName: 'adozasi_szint', groupIndex: 3 },
];
